var render = function render(){var _vm=this,_c=_vm._self._c;return _c('hr',{staticClass:"s-divider",class:{'vertical': _vm.vertical},style:(_vm.componentStyle),attrs:{"aria-orientation":"horizontal","role":"separator"}})
}
var staticRenderFns = []

export { render, staticRenderFns }